const sensisitiveStorageKeys = ['access_token', 'refresh_token', 'id_token', 'client_id', 'session_id'];

const mask = '****';

const parseObjectByKey = (key: string, data: string | object) => {
  if (typeof data === 'string') {
    try {
      const parsedData = JSON.parse(data);
      return parseObjectByKey(key, parsedData);
    } catch (_err) {
      // this is normal string value, not JSON strigified, but could be sensitive
      if (sensisitiveStorageKeys.includes(key.toLowerCase())) {
        return mask;
      }

      return data;
    }
  }

  if (typeof data === 'object' && data !== null) {
    return Object.keys(data).reduce(
      (acc, key) => {
        if (sensisitiveStorageKeys.includes(key.toLowerCase())) {
          acc[key] = mask;
        } else {
          acc[key] = parseObjectByKey(key, data[key]);
        }
        return acc;
      },
      {} as Record<string, string | object>
    );
  }

  return data;
};

export const getSensitiveDataHidden = (data: Storage): Record<string, string | object> => {
  const storageKeys = Object.keys(data);

  return storageKeys.reduce(
    (acc, key) => {
      acc[key] = parseObjectByKey(key, data.getItem(key) || '');
      return acc;
    },
    {} as Record<string, string | object>
  );
};
